import ArrondissementPage from "../ArrondissementPage";
import { arrondissementsData } from "@/mocks/arrondissements";

export default function ParisArrCentrePage() {
  const data = arrondissementsData.find((a) => a.slug === "centre")!;
  return <ArrondissementPage data={data} />;
}
